export const INICIAR_SESION_CORRECTO = "INICIAR_SESION_CORRECTO"

export const CERRAR_SESION = "CERRAR_SESION"